export const billingPortalBaseUrl = process.env.REACT_APP_BASE_URL + "/wbimpactors/billing/";